import tw from 'twin.macro';

export const Container = tw.div`
  mx-auto max-w-7xl px-6 lg:px-8
`;

export const Title = tw.h2`
  text-5xl  tracking-tight text-center mb-5
`;

export const Year = tw.p`
  text-lg text-center font-medium
`;

export const List = tw.ul`
  text-lg ml-auto sm:ml-52 mt-8 space-y-4 text-left font-medium list-disc
`;

export const ListItem = tw.li`
  text-left
`;
